import { ThirdTicketInfo, type TicketDetail } from '@/api/tickets'
import B_COUPON from '@/composables/ticket/coupon'

interface ITicketState {
  ticketDetail: TicketDetail
  cityCode: string
  isThirdPartScenic: boolean
}

export default {
  namespaced: true,
  state: () => ({
    ticketDetail: {},
    cityCode: '',
    isThirdPartScenic: false
  }),
  mutations: {
    setTicketDetail(state: ITicketState, payload: TicketDetail) {
      state.isThirdPartScenic = payload.spotType === 1
      state.ticketDetail = payload
    },
    setThirdSkuList(state: ITicketState, payload: ThirdTicketInfo[]) {
      state.ticketDetail.thirdCmmdtySpecs = payload
    },
    setCityCode(state: ITicketState, payload: string) {
      state.cityCode = payload
    }
  },
  getters: {
    ticketDetail(state: ITicketState) {
      return state.ticketDetail
    },
    cityCode(state: ITicketState) {
      return state.cityCode
    },
    thirdSpotId(state: ITicketState) {
      return state.ticketDetail.thirdScenicSpotInfo?.spotId
    },
    spotId(state: ITicketState) {
      return state.ticketDetail.scenicSpotInfo?.spotId
    }
  }
}
